<template>
<div>
  <DetailListHeader :title="title"/>
  <DetailListItem v-if="terminations.length === 0" title="Cannot Be Formed" />
  <DetailListItem v-if="terminations.length > 1" :title="getManyTitle(terminations)" />
  <DetailListItem
    v-if="terminations.length === 1"
    :title="terminations[0].position"
    :figureIndex="terminations[0].id"
  />
</div>
</template>

<script>
import DetailListHeader from './DetailListHeader.vue'
import DetailListItem from './DetailListItem.vue'

export default {
  name: 'ViaPuncti',
  components: {
    DetailListHeader,
    DetailListItem,
  },
  props: {
    title: String,
    element: String,
  },
  computed: {
    terminations() {
      if (this.element === 'fire') {
        return this.$store.state.viaPunctiFire
      }
      if (this.element === 'air') {
        return this.$store.state.viaPunctiAir
      }
      if (this.element === 'water') {
        return this.$store.state.viaPunctiWater
      }
      if (this.element === 'earth') {
        return this.$store.state.viaPunctiEarth
      }

      return []
    }
  },
  methods: {
    getManyTitle (terminations) {
      return `${terminations.length} Passive`
    },
  }
}
</script>

<style lang="scss" scoped>
</style>
